(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["vue-js-popover"] = factory(require("vue"));
	else
		root["vue-js-popover"] = factory(root["vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 